import React from "react";
//#region types
import { CustomNode, CustomTreeProps, TreeDChartProps } from "models/propTypes/chartProps";
import { GraphConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Tree from "react-d3-tree";
import { RectangularNode } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import "theme/custom/d3-tree.css";

export default function TreeChart(props: TreeDChartProps) {
  const { data, id } = props;

  const chartContainerId = `${GraphConstants.TreeChartIdPrefix}${GraphConstants.ContainerIdPrefix}${id}`;

  const renderTreeNode = (rd3tNodeProps: CustomNode) => {
    return <RectangularNode node={rd3tNodeProps}></RectangularNode>;
  };

  const initialProps = {
    data: data,
    orientation: "horizontal",
    centeringTransitionDuration: 800,
    pathFunc: "step",
    collapsible: true,
    shouldCollapseNeighborNodes: false,
    zoomable: true,
    draggable: true,
    zoom: 1,
    scaleExtent: { min: 0.1, max: 1 },
    separation: { siblings: 2, nonSiblings: 2 },
    nodeSize: { x: 250, y: 100 },
    enableLegacyTransitions: true,
    transitionDuration: 500,
    renderCustomNodeElement: renderTreeNode,
    styles: {
      nodes: {
        node: {
          circle: {
            fill: GraphConstants.NodeFillColor,
          },
          attributes: {
            stroke: GraphConstants.NodeStrokeColor,
            strokeWidth: "2",
          },
        },
        leafNode: {
          circle: {
            fill: GraphConstants.NodeFillColor,
          },
          attributes: {
            stroke: GraphConstants.NodeStrokeColor,
            strokeWidth: "2",
          },
        },
      },
    },
  } as CustomTreeProps;

  React.useEffect(() => {
    const treeContainer = document.getElementById(chartContainerId);
    const svg = treeContainer?.querySelector("svg");
    const innerSvg = svg?.querySelector("g");

    if (innerSvg != null && innerSvg !== undefined) {
      const bBox = innerSvg?.getBBox();

      const margin = 50;
      if (svg && bBox) {
        svg.style.minHeight = (bBox?.height + margin * 2).toString().concat("px");
      }

      const scaleX = 0.9;
      const scaleY = 0.9;

      innerSvg.setAttribute("transform", `translate(${-bBox.x},${-bBox.y + margin}) scale(${scaleX},${scaleY})`);
    }
  }, [chartContainerId, data]);

  return (
    <Grid container id={chartContainerId} className={cssExports.treeContainer}>
      <Tree {...initialProps} data={data} />
    </Grid>
  );
}
